import { render, staticRenderFns } from "./hollandTest.vue?vue&type=template&id=295dd16e&scoped=true&"
import script from "./hollandTest.vue?vue&type=script&lang=js&"
export * from "./hollandTest.vue?vue&type=script&lang=js&"
import style0 from "./hollandTest.vue?vue&type=style&index=0&id=295dd16e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295dd16e",
  null
  
)

export default component.exports